/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {Row , Col, Card} from 'react-bootstrap';
import CDNImage from '../../image';
import CDNAudio from '../../audio';


export default class VocabContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    isArabic(text){
        var arabicTestString = /[\u0600-\u06FF]/;
        return arabicTestString.test(text)
    }

    getVocabSection(vocabObject) {
        let audio = null;
        return <Col md={12}><table style={{width:'100%'}}>
            <tr>
                <td>
                    <b sm={vocabObject.learningAudio ? 11 : 12} style={{fontSize:this.isArabic(vocabObject.word) ? "16px" : null, textAlign:this.isArabic(vocabObject.word) ? "right" : "left" }}>{vocabObject.word}</b>
                </td>
                <td style={{width:'20px'}}>
                    {audio}
                </td>
            </tr>
            </table></Col>
    }

    componentWillReceiveProps(props){

        this.props = props;
        this.setState({
            update:true,
        })

    }

    playAudio(path){
        (new CDNAudio(path)).play();
    }

    render() {
        if (this.props.vocabTranslations == undefined) {
            return "";
        }
        var VocabObjects = [];
        let _alert = null;
        let _alertB = null;

        if(this.props.vocabTranslations > 10)
        {
             _alert = <i>Students will be assigned 10  at random from the list below</i>
            _alertB = <i>Students will be assigned 10  at random from the list above</i>
        }
        for (var idx = 0 ; idx < this.props.vocabTranslations.length; idx++) {
            VocabObjects.push(<Col md={6}>{this.getVocabSection(this.props.vocabTranslations[idx])}</Col>);
        }
        return <div>
                <div style={{padding:'20px'}}>
                    {_alert}
                    <Row className="p-t-10">
                        {VocabObjects}
                    </Row>
                    {_alertB}
                </div>
            </div>
    }

}